import type { ReviewStoreRow } from "../../../types/reviews";

const STORE_LABEL: Record<string, string> = { shopify: "Shopify", rakuten: "楽天市場", amazon: "Amazon" };
const STORE_COLOR: Record<string, string> = { shopify: "var(--rv-shopify)", rakuten: "var(--rv-rakuten)", amazon: "var(--rv-amazon)" };

export function StoreCards({ stores }: { stores: ReviewStoreRow[] }) {
  return (
    <div className="rv-store-cards">
      {stores.map((s) => (
        <div className="rv-store-card" style={{ borderTopColor: STORE_COLOR[s.store] }} key={s.store}>
          <div className="rv-store-head">
            <span className="rv-card-title">
              {STORE_LABEL[s.store]}
              {!s.connected && (
                <span className="rv-tag rv-tag--muted" style={{ marginLeft: 8 }}>
                  未連携
                </span>
              )}
            </span>
            {s.connected && <span className="rv-card-sub">構成比 {s.share}%</span>}
          </div>
          {s.connected ? (
            <div className="rv-store-mini-grid">
              <div className="rv-store-mini-item">
                <span className="rv-store-mini-label">平均評価</span>
                <span className="rv-store-mini-value">{s.avg !== null ? s.avg.toFixed(1) : "―"}</span>
              </div>
              <div className="rv-store-mini-item">
                <span className="rv-store-mini-label">件数</span>
                <span className="rv-store-mini-value">{s.count}</span>
              </div>
              <div className="rv-store-mini-item">
                <span className="rv-store-mini-label">商品レビュー記入率</span>
                <span className="rv-store-mini-value">{s.fillRate !== null ? `${s.fillRate}%` : "―"}</span>
                {s.shopFillRate != null && (
                  <span className="rv-store-mini-label">ショップ {s.shopFillRate}%</span>
                )}
              </div>
              <div className="rv-store-mini-item">
                <span className="rv-store-mini-label">低評価</span>
                <span className="rv-store-mini-value">{s.low}</span>
              </div>
            </div>
          ) : (
            <div className="rv-empty" style={{ padding: "12px 0" }}>
              連携が完了次第データを表示します。
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
